






import { defineComponent } from '@vue/composition-api';

// This component is an empty fallback for when Gaming components cannot be loaded, so that the remainder
// of the app keeps functioning. It must satisfy the following conditions:
// 1. It renders empty content
// 2. It passes _something_ to the default slot, otherwise some consumers will not work because the are expecting that gaming component has default slot
export default defineComponent({
    name: 'FederationFallback',
});
